// Smart Maji logo, drawn as SVG so it stays sharp at any size and can switch colours
// for dark backgrounds. Mark: water drop with a meter/circuit symbol and a signal.
//   <LogoMark size={32} />                       mark only
//   <Logo height={36} variant="dark" />          mark + "Smart Maji" (variant: light | dark)
//   <Logo height={48} tagline />                 adds "iot water metering · kenya"
export const BRAND_BLUE = '#1a5fa4';
const BRAND_BLUE_ON_DARK = '#4a9be0';
const WORD_FONT = "'Lato', 'IBM Plex Sans', system-ui, sans-serif";

export function LogoMark({ size = 32, color = BRAND_BLUE, title }) {
  return (
    <svg width={size * (245 / 410)} height={size} viewBox="90 30 245 410" role={title ? 'img' : undefined} aria-label={title} aria-hidden={title ? undefined : true}>
      {/* signal */}
      <path d="M240 46 A76 76 0 0 1 316 122 M240 82 A40 40 0 0 1 280 122" fill="none" stroke={color} strokeWidth="15" strokeLinecap="round" />
      {/* drop */}
      <path d="M243 125 C 278 178, 330 245, 330 320 A 115 112 0 0 1 100 320 C 100 246, 186 186, 243 125 Z" fill={color} />
      {/* meter / circuit */}
      <g stroke="#fff" strokeWidth="11" fill="none" strokeLinecap="round" strokeLinejoin="round">
        <path d="M134 326 H172 M197 300 V250 H246 M197 352 V392 H226" />
      </g>
      <g fill="#fff">
        <circle cx="130" cy="326" r="11" /><circle cx="252" cy="250" r="11" /><circle cx="232" cy="392" r="11" />
        <rect x="171" y="300" width="54" height="52" rx="10" />
      </g>
      <circle cx="198" cy="326" r="10" fill={color} />
    </svg>
  );
}

export default function Logo({ height = 36, variant = 'light', tagline = false, style }) {
  const dark = variant === 'dark';
  const blue = dark ? BRAND_BLUE_ON_DARK : BRAND_BLUE;
  const word = Math.round(height * 0.62);
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: Math.round(height * 0.28), lineHeight: 1, ...style }}>
      <LogoMark size={height} color={blue} />
      <span style={{ display: 'inline-flex', flexDirection: 'column', gap: Math.round(height * 0.12) }}>
        <span style={{ fontFamily: WORD_FONT, fontSize: word, letterSpacing: -0.2, whiteSpace: 'nowrap' }}>
          <span style={{ color: dark ? '#f5f2ec' : '#1c1c1c', fontWeight: 400 }}>Smart </span>
          <span style={{ color: blue, fontWeight: 700 }}>Maji</span>
        </span>
        {tagline && (
          <span style={{ fontFamily: WORD_FONT, fontSize: Math.max(9, Math.round(height * 0.2)), letterSpacing: 2.2, color: dark ? '#c6d2dd' : '#2a2a2a', whiteSpace: 'nowrap' }}>
            iot water metering · kenya
          </span>
        )}
      </span>
    </span>
  );
}
